import React from "react";
import "./App.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Box, Grid, IconButton } from "@material-ui/core";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Register from "./containers/Register";
import logo from "./gabi-logo.png";

const Stkey =
  process.env.REACT_APP_STAGE === "production"
    ? "pk_live_51Jk8CCKfL3WsUMzrgl5LI0Gj9fi6uTVvOGeSUKcvGMDO4XtVV7GBzzq4wLCLUZoWdWdwZ5EDLW5JYnwSHegkx2po00zMxJ7iRU"
    : "pk_test_51Jk8CCKfL3WsUMzrOFBymw1QPmtVpSSs1Y8gCSq70OdxZR9XhirmrsJ55wVjn7d14AfouNg76CBHvYr70OiAqyim007tuXz4Ew";

const stripePromise = loadStripe(Stkey);

const THEME = createTheme({
  typography: {
    fontFamily: `"Open Sans", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&:hover $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&$focused $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&$disabled $notchedOutline": {
          borderColor: "#F4F7FC",
        },
      },
    },
  },
});

function App() {
  return (
    <MuiThemeProvider theme={THEME}>
      <Box my={4} style={{ marginTop: 0, marginBottom: 0 }}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              padding: "0 40px 140px 40px",
              height: "100vh",
            }}
            className="bg-container"
          >
            <IconButton
              href="https://www.gabilabs.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ padding: "12px 0 0 0" }}
            >
              <img
                src={logo}
                style={{
                  height: 60,
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                alt="header logo"
              />
            </IconButton>
            <Elements stripe={stripePromise}>
              <Register />
            </Elements>
          </Grid>
        </Grid>
      </Box>
    </MuiThemeProvider>
  );
}

export default App;
